module.exports = __webpack_public_path__ + "img/order.a4012a5e.svg";